let notificationTitle = {
  default: '',
  danger: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Information',
}

function generateNotificationBody(type: keyof typeof notificationTitle, message: any, toastr: any, timeOut: any) {
  toastr.show(
    `
      <span class="alert-icon ni ni-bell-55" data-notify="icon"></span>
      <div class="alert-text">
        <span class="alert-title" data-notify="title">${notificationTitle[type]}</span>
        <span data-notify="message">${message}</span>
      </div>
    `,
    '',
    {
      timeOut: timeOut,
      closeButton: true,
      enableHtml: true,
      tapToDismiss: false,
      titleClass: 'alert-title',
      positionClass: 'toast-top-center',
      toastClass:
        `ngx-toastr alert alert-dismissible alert-${type} alert-notify`,
    }
  );
}

export function showNotification(type: keyof typeof notificationTitle, message: any, toastr: any, timeOut = 5000) {
  generateNotificationBody(type, message, toastr, timeOut = 5000)
}
